define('app-Discounts/main',['./settings', '../app/ui/dialog'], function (settings, dialog) {
    return {
        run: function () {
            var container = $(settings.container);

            if (container.length === 0) {
                window.log('No Discounts pop ups located. Discounts popups will not be available');
                return;
            }

            window.log('Loading Data Tag Pop Up App');

            container.on("click", function (event) {
                event.preventDefault();

                var contentDiv = $('<div/>');
                var data = JSON.parse($(this).attr('data-object'));
                var title = data.HowItWorksText;

                contentDiv.append(data.HowItWorksDescription);
                dialog.show(title, contentDiv);
            });

            window.loadedModules('app-Discounts');
        }
    }
});
